module.exports = __webpack_public_path__ + "img/organizations-logo.ee9ae22c.svg";